import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

export default function useProvozniInformacePosledni(pocet = 5) {
  return useDataLoader({
    url: DATA.provozniInformacePosledni(pocet),
    method: "get"
  });
}
